import { render } from "./NuovoRapportinoPresenza.vue?vue&type=template&id=43196b26&scoped=true"
import script from "./NuovoRapportinoPresenza.vue?vue&type=script&lang=js"
export * from "./NuovoRapportinoPresenza.vue?vue&type=script&lang=js"

import "./NuovoRapportinoPresenza.vue?vue&type=style&index=0&id=43196b26&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43196b26"]])

export default __exports__